import { Skeleton } from '@/shared/components';
import styles from './LoadingScreen.module.css'

export function LoadingScreen() {
  return (
    <div className={styles.basicWrapper}>
      <div className={styles.loadingTitle}>
        <Skeleton
          width={"100%"}
          height={"3.3rem"}
          borderRadius='0'
          bgColor=''
        />
      </div>

      <div className={styles.loadingContainer}>
        <Skeleton
          width={"36rem"}
          height={"4.8rem"}
          borderRadius='2.4rem'
        />
        <Skeleton
          width={"100%"}
          height={"100%"}
          borderRadius='1.2rem'
        />
        <Skeleton
          width={"100%"}
          height={"3.6rem"}
          borderRadius='0.4rem'
        />
      </div>
    </div>
  );
}